import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { consumeMagicLink } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TwoFactorForm } from "@/components/auth/TwoFactorForm";

export const MagicPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState(false);
  const [challenge, setChallenge] = useState(null);
  const destFor = (res) => {
    const next = params.get("next") || "";
    return /^\/account(\/[A-Za-z0-9/_-]*)?$/.test(next) ? next : res.process_id ? `/account/processes/${res.process_id}` : "/account";
  };
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      navigate("/account/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await consumeMagicLink(token);
        if (res.valid && res.two_factor_required) {
          setChallenge({ token: res.challenge, dest: destFor(res) });
        } else if (res.valid && res.access_token) {
          loginWithToken(res.access_token, res.user);
          const next = params.get("next") || "";
          const dest = /^\/account(\/[A-Za-z0-9/_-]*)?$/.test(next)
            ? next
            : res.process_id ? `/account/processes/${res.process_id}` : "/account";
          navigate(dest, { replace: true });
        } else {
          setError(true);
          setTimeout(() => navigate("/account/login", { replace: true }), 1800);
        }
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/account/login", { replace: true }), 1800);
      }
    })();
  }, [params, navigate, loginWithToken]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
      {challenge ? (
        <div className="w-full max-w-sm rounded-2xl border border-slate-800 bg-slate-900/60 p-6">
          <TwoFactorForm tone="green" challenge={challenge.token} onDone={(tok, u) => { loginWithToken(tok, u); navigate(challenge.dest, { replace: true }); }} />
        </div>
      ) : (
      <div className="flex flex-col items-center gap-3">
        {!error ? (
          <>
            <Loader2 className="h-6 w-6 animate-spin text-emerald-400" />
            <p className="text-sm">Signing you in...</p>
          </>
        ) : (
          <p className="text-sm text-red-300">This link is invalid or has expired. Redirecting to login...</p>
        )}
      </div>
      )}
    </div>
  );
};

export default MagicPage;
